import { Configuration } from "../types/Configuration";
import { getUserRoleFromToken } from "../utils/Auth";
import api from "../utils/axios";

export const getDocumentTypes = async () => {
	try {
		const response = await api.get("ListOptions/document-types");
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.log("An Error occurred geting the Document Types:" + error);
		return [];
	}
};

export const getCashRegisters = async () => {
	try {
		const response = await api.get("ListOptions/cash-register");
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.log("An Error occurred geting the Cash Registers:" + error);
		return [];
	}
};

export const fetchZones = async () => {
	try {
		const response = await api.get("Zone/zones");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch zones.");
		}
	} catch (error) {
		console.error("An error occurred while fetching zones:", error);
	}
};

export const fetchStatus = async () => {
	try {
		const response = await api.get("ListOptions/selectorderstatus");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const fetchUserRoles = async () => {
	try {
		const response = await api.get("ListOptions/select-user-roles");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const fetchSettlementStatuses = async () => {
	try {
		const response = await api.get("ListOptions/select-settlement-status");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const getConfigurationStatus = async (id: number | null) => {
	try {
		const response = await api.get("ListOptions/select-configurations", {
			params: { id },
		});
		if (response.status === 200) {
			return response?.data[0].status;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const getConfigurationValue = async (id: number | null) => {
	try {
		const response = await api.get("ListOptions/select-configurations", {
			params: { id },
		});
		if (response.status === 200) {
			return response?.data[0].value;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const getAllCustoms = async () => {
	try {
		const response = await api.get("ListOptions/get-costums");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};
export const fetchUserCashRegister = async () => {
	try {
		const response = await api.get("UserCashRegister");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const fetchMenuAccess = async () => {
	const roleId = getUserRoleFromToken();
	try {
		const response = await api.get("Menu/select-menus", {
			params: { roleId },
		});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.log("An Error occurred geting the Cash Registers:" + error);
		return [];
	}
};

export const getGoogleApiKey = async () => {
	try {
		const response = await api.get<Configuration>(
			"Configuration/google-api-key"
		);
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch the api key.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};
